import { Client } from "@/manager/client/client.model";
import { Employee } from "@/shared/models/employee.model";
import { Bill } from "@/clickbuy/purchase/models/bill.model";
import { PurchaseLine } from "@/clickbuy/purchase/models/purchase-line.model";

export enum PurchasePaymentStatus {
  Pending = 1,
  Paid = 2,
  Canceled = 3
}

export enum PurchaseCompletionStatus {
  Pending = 1,
  Finished = 2,
  Editable = 3
}

export enum PaymentMethod {
  Cash = 1,
  Card = 2,
  DirectDebit = 3,
  SendWireTransfer = 4,
  Bizum = 5,
  Web = 6
}

export const PaymentMethodLiteral = [
  "Sin indicar",
  "Efectivo",
  "Tarjeta",
  "Domiciliación",
  "Transferencia",
  'Bizum',
  'Web'
];

export interface PurchaseInterface {
  id?: string;
  bill?: Bill;
  client: Client;
  employee?: Employee;
  document?: string;
  tags?: Array<Record<string, string>>;
  convocationOrigin?: string;
  internalBussiness?: string;
  paymentStatus?: PurchasePaymentStatus;
  completionStatus?: PurchaseCompletionStatus;
  paymentMethod: PaymentMethod;
  canceledSuperiorPurchase?: boolean;
  superiorPurchase?: string;
  reserveAmount?: number;
  previousReserveAmount?: number;
  totalAmount?: number;
  totalPrice?: number;
  totalPriceTax?: number;
  totalPriceWithoutTax?: number;
  totalPaymentPending?: number;
  note?: string;
  hasNote?: boolean;
  purchaseLines: PurchaseLine[];
  publicId?: number;
  billFiscalData?: boolean;
  addNewPurchase?: boolean;
  reserveAmountTouched?: boolean;
  soonPaymentPurchaseCheck?: boolean;
  voucherNumber?: string;
  voucherOwner?: Client;
  fiscalDataExtensionId?:any;
  fiscalData?:any;
}

export class Purchase implements PurchaseInterface {
  public id?: string;
  public bill?: Bill;
  public client: Client;
  tags?: Array<Record<string, string>>;
  public employee?: Employee;
  public document?: string;
  public created?: string;
  public convocationOrigin?: string;
  public internalBussiness?: string;
  public paymentStatus?: PurchasePaymentStatus;
  public completionStatus?: PurchaseCompletionStatus;
  public paymentMethod: PaymentMethod;
  public cardLastDigits?: string;
  public canceledSuperiorPurchase?: boolean;
  public superiorPurchase?: string;
  public reserveAmount?: number;
  public previousReserveAmount?: number;
  public totalAmount?: number;
  public totalPrice?: number;
  public totalPriceTax?: number;
  public totalPriceWithoutTax?: number;
  public totalPaymentPending?: number;
  public soonPaymentDiscount?: number;
  public soonPaymentPurchaseCheck?: boolean;
  public note?: string;
  public hasNote?: boolean;
  public purchaseLines: PurchaseLine[];
  public publicId?: number;
  public billFiscalData?: boolean;
  public addNewPurchase?: boolean;
  public reserveAmountTouched?: boolean;
  public voucherNumber?: string;
  public voucherOwner?: Client;
  public fiscalDataExtensionId?:any;
  public modifyPurchase?:Boolean;
  public fiscalData?:any;

  constructor() {
    this.client = new Client();
    const newLine = new PurchaseLine();
    this.purchaseLines = [newLine];
    this.paymentMethod = PaymentMethod.Cash;
    this.billFiscalData = true;
    this.addNewPurchase = false;
    this.reserveAmountTouched = false;
    this.soonPaymentPurchaseCheck = false;
    this.modifyPurchase = false;
  }
}
